import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InvoicesState } from '../../models/invoices.model';

export const selectInvoicesState = createFeatureSelector<InvoicesState>('invoices');

export const selectIsLoading = createSelector(
    selectInvoicesState,
    (state: InvoicesState) => state.isLoading
);

export const selectInvoices = createSelector(
    selectInvoicesState,
    (state: InvoicesState) => state.invoices
);

export const selectTotalItems = createSelector(
    selectInvoicesState,
    (state: InvoicesState) => state.totalItems
);

export const selectTotalPages = createSelector(
    selectInvoicesState,
    (state: InvoicesState) => state.totalPages
);

export const selectInvoice = createSelector(
    selectInvoicesState,
    (state: InvoicesState) => state.selectedInvoice
);

export const selecteSelectedInvoiceId = createSelector(
    selectInvoicesState,
    (state: InvoicesState) => state.selectedInvoiceId
);

export const selectInvoicesFilter = createSelector(
    selectInvoicesState,
    (state: InvoicesState) => state.filters
);

export const selectRecalculateLoading = createSelector(
    selectInvoicesState,
    (state: InvoicesState) => state.recalculateLoading
);

export const selectRecalculateResult = createSelector(
    selectInvoicesState,
    (state: InvoicesState) => state.recalculateResult
);

export const selectRecalculateError = createSelector(
    selectInvoicesState,
    (state: InvoicesState) => state.recalculateError
);
